function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { DialogTitle as MUIDialogTitle } from "@mui/material";
import { styled } from "@mui/material/styles";
const RootMuiDialogTitle = styled(MUIDialogTitle, {
  shouldForwardProp: props => props !== "variant"
})(_ref => {
  let {
    theme,
    variant
  } = _ref;
  return !variant ? {
    ...theme.typography.h6
  } : {
    ...theme.typography[variant]
  };
});
export const DialogTitle = props => /*#__PURE__*/React.createElement(RootMuiDialogTitle, _extends({}, props, {
  sx: {
    backgroundColor: "#ffffff"
  }
}));
export default DialogTitle;